export const handleInvoiceClick = (RoleName, Invoice_Status, Invoice_Id, vendorCode) => {
  console.log("list Role", RoleName, Invoice_Status, Invoice_Id);
  const roleRoutes = {
    'Taxteam': 'taxteamdetail',
    'DeptCoordinator': 'departmentDetail',
    'IP': 'processInvoiceDetail',
    'IR': 'NewInvoiceDetail',
    'LoamApprover': 'LoamDetail',
    'I2P Initiator': 'NewInvoiceDetail',
    'Import': 'NewInvoiceDetail',
    'APSupervisor': 'APS_InvoiceDetailPage',
    'Reviewer': 'reviwerInvoiceDetail',
    'HR': 'NewInvoiceDetail',
    'EFDVInitiator': 'NewInvoiceDetail',
    'LineManager': 'LineManagerDetail',
    'SharedServices': 'SharedServicesDetail',
    'DirectorHR': 'DirectorHRDetail',
    'APManager': 'APS_InvoiceDetailPage',
    'APGM': 'APS_InvoiceDetailPage',
    'PRInitiator': 'NewInvoiceDetail',
    'Initiator':'NewInvoiceDetail',
  };
  if (roleRoutes.hasOwnProperty(RoleName)) {
    window.open(`/#/${roleRoutes[RoleName]}?invoiceId=${Invoice_Id}&roleName=${RoleName}&status=${Invoice_Status}&vendorCode=${vendorCode}&edit=false`, "_blank");
  } 
  else if (Invoice_Status === "PAID" ||  Invoice_Status === "Completed" ) {
    window.open(`/#/APS_InvoiceDetailPage?invoiceId=${Invoice_Id}&roleName=AP Supervisor&status=${Invoice_Status}&vendorCode=${vendorCode}&edit=false`, "_blank");
  }
  else {
    window.open(`/#/InvDetailPage?inv=${Invoice_Id}&vendorCode=${vendorCode}`, "_blank");
  }
};